<div>
  <i  class="fas" [ngClass]="{
    'fa-fire': device.model === 'NABOO',
    'fa-water': device.model === 'ORACLE',
    'fa-snowflake': device.model === 'NEO'
  }"></i>
</div>